export default __webpack_public_path__ + "static/media/self-portrait-crop.529818c2.jpg";